import React from 'react';
import PropTypes from 'prop-types';
import BookPreview from '../../components/BookPreview';
import CanvasDrawers from '../../components/CanvasDrawers';

import './Canvas.scss';

const Canvas = props => (
  <section className="canvas">
    <h1 className="canvas-title">{props.title}</h1>
    <BookPreview
      covers={props.primary.bookPages}
      breadcrumbCTA={props.primary.breadcrumbsCta}
      breadcrumbs={props.primary.breadcrumbs}
      sortBreadcrumbs={props.primary.sortBreadcrumbs}
      productId={props.primary.productId}
      drawers={props.drawers}
      completedDrawersMap={props.completedDrawersMap}
    />
    {props.isDrawersVisible && (
      <CanvasDrawers
        productId={props.primary.productId}
        prismicProduct={props.prismicProduct}
        drawers={props.drawers}
        completedText={props.completedCtaText}
        continueText={props.continueCtaText}
        completedDrawersMap={props.completedDrawersMap}
        showSaveForLaterButton={props.showSaveForLaterButton}
        saveForLaterCtaText={props.primary.saveForLaterCtaText}
        saveForLaterCtaIcon={props.primary.saveForLaterCtaIcon}
      />
    )}
    <div className={`canvas-overlay ${props.isDrawerOpen ? 'canvas-overlay--visible' : '' }`} />
  </section>
);

Canvas.propTypes = {
  isDrawersVisible: PropTypes.bool.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  completedDrawersMap: PropTypes.object.isRequired,
  completedCtaText: PropTypes.string.isRequired,
  continueCtaText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  primary: PropTypes.shape({
    cta: PropTypes.string.isRequired,
    hasGiftwrap: PropTypes.bool,
    productId: PropTypes.string.isRequired,
    bookPages: PropTypes.array.isRequired,
    breadcrumbs: PropTypes.array,
    breadcrumbsCta: PropTypes.string,
    sortBreadcrumbs: PropTypes.string,
    saveForLaterCtaText: PropTypes.string,
    saveForLaterCtaIcon: PropTypes.string,
  }),
  drawers: PropTypes.shape({
    form: PropTypes.object,
    other: PropTypes.array,
  }),
  prismicProduct: PropTypes.object,
  showSaveForLaterButton: PropTypes.bool,
};

export default Canvas;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Canvas/Canvas.js